export default __webpack_public_path__ + "static/media/sample.74e62743.png";